<div pFocusTrap [pFocusTrapDisabled]="!visible">
  <p-sidebar
    #sidebarElement
    styleClass="side-panel {{ size === 'medium' ? 'side-panel--medium' : 'side-panel--large' }} {{ spacing ? 'side-panel--spacing' : '' }}"
    [(visible)]="visible"
    [fullScreen]="fullScreen"
    [position]="position"
    (onHide)="onSidebarHide()"
    (onShow)="onSidebarShow()"
    [autoZIndex]="false"
    [attr.aria-label]="title || 'Side panel'"
  >
    <ng-template pTemplate="header">{{ title }}</ng-template>
    <ng-template pTemplate="content"><ng-content></ng-content></ng-template>
    <ng-template pTemplate="footer">
      <div class="side-panel__footer" *ngIf="footerButtonText">
        <lx-button
          [class.side-panel__footer__button--adult]="activeFlow === Flows.Adult"
          [class.side-panel__footer__button--junior]="activeFlow === Flows.Junior"
          [text]="footerButtonText"
          [block]="true"
          [btnRounded]="true"
          [buttonStyle]="'primary'"
          [disabled]="footerButtonDisabled"
          (buttonClick)="footerButtonClicked.emit()"
          (keydown.enter)="footerButtonClicked.emit()"
          tabindex="0"
          [tabindex]="'-1'"
          data-qa="footer-button-side-panel"
        >
        </lx-button>
      </div>

      <ng-content select="footer"></ng-content>
    </ng-template>
  </p-sidebar>
</div>
